import React from 'react';
import PropTypes from 'prop-types';
import enhance from './enhance';

export const SubmissionButton = ({
  buttonText,
  submitOrder,
  isWebShopClosed,
  isSubmissionButtonDisabled,
  buttonStyling,
  themeStyle,
}) => (
  <button
    className={buttonStyling}
    onClick={submitOrder}
    disabled={isSubmissionButtonDisabled}
    style={themeStyle}
  >
    {buttonText}
  </button>
);

SubmissionButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  submitOrder: PropTypes.func.isRequired,
  isWebShopClosed: PropTypes.bool.isRequired,
  isSubmissionButtonDisabled: PropTypes.bool.isRequired,
  buttonStyling: PropTypes.string.isRequired,
};

export default enhance(SubmissionButton);
